module.exports = __webpack_public_path__ + "static/media/covi_min_pub_enc.fd65b478.png";